module.exports = "/images/ecommerce.png?47b5ad52dcac1b2a50e4a4000c95f69f";